import { create } from 'zustand';
import type { DragPath } from 'src/types';

export interface AiComposerTarget {
  blockId: string;
  path: DragPath;
}

interface AiComposerState {
  /** Whether the "Draft with AI" composer is open (mounted by the editor pages). */
  open: boolean;
  /**
   * When opened from a block's ✨ quick action, the canvas object the draft
   * should focus on (scope = that block). Null when opened from the toolbar.
   */
  target: AiComposerTarget | null;
  openComposer: (target?: AiComposerTarget | null) => void;
  closeComposer: () => void;
}

/** Global open/close state so any component (toolbar, block ✨, ⌘J) can open the composer. */
export const useAiComposer = create<AiComposerState>((set) => ({
  open: false,
  target: null,
  openComposer: (target = null) => set({ open: true, target }),
  closeComposer: () => set({ open: false, target: null }),
}));
